export const regexPasswordValidation = new RegExp(
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$!?^",.:;'*&@#_-])[0-9a-zA-Z$!?^",.:;'*&@#_-]{8,}$/,
);

export const regexPasswordPhrase = `A senha deve conter pelo menos 1 caractere especial $!?.^",:'*;&_@-# 1 letra maiúscula, 1 letra minúscula, 1 número e conter pelo menos 8 dígitos`;
